import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { of } from 'rxjs';

import { I18nService } from '@nghedgehog/angular-ui';

import { environment } from '../../../environments/environment';

@Injectable()
export class AwooInterceptor implements HttpInterceptor {
  i18n = inject(I18nService);

  get isChinese() {
    const language = this.i18n.language;
    return language === 'zh' || language === 'zh-tw';
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (!req.url.startsWith(environment.awoo.url)) {
      return next.handle(req);
    }

    if (!this.isChinese) {
      const mockResponse = new HttpResponse({
        body: {
          errcode: '',
          errmsg: '',
          requestId: '',
          result: {
            tags: [],
            products: {
              'directions:v': { products: [] },
              'directions:h': { products: [] },
            },
          },
        },
      });
      return of(mockResponse);
    }

    const serverReq = req.clone({
      setHeaders: {
        authorization: `Bearer ${environment.awoo.token}`,
      },
    });

    return next.handle(serverReq);
  }
}
